@if (visible$()) {
  <div data-shortcut-layer="popover" class="sol-popovers-container">
    @for (popover of popovers$(); track popover.id; let last = $last) {
      <sol-popover [attr.data-sol-popover-id]="popover.id" [data]="popover" [cdkTrapFocus]="last" />
    }
  </div>
}
